(function () {
  var legacyWholesaleHost = 'wholesale.waterandwellness.com';
  var wholesalePage = '/pages/wholesale';

  function normalizeWholesaleLinks() {
    document.querySelectorAll('a[href*="' + legacyWholesaleHost + '"]').forEach(function (link) {
      link.setAttribute('href', wholesalePage);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeWholesaleLinks);
  } else {
    normalizeWholesaleLinks();
  }
})();

(function () {
  function isShopAllCollection() {
    return window.location.pathname.replace(/\/$/, '') === '/collections/all';
  }

  function getSectionHandle(section) {
    if (!section || !section.id) return '';
    return section.id.replace('shopify-section-', '');
  }

  function sectionUrl(sectionHandle, nextUrl) {
    var url = new URL(nextUrl || window.location.href, window.location.origin);
    url.searchParams.set('section_id', sectionHandle);
    url.searchParams.set('ww_shop_all_refresh', Date.now().toString());
    return url.toString();
  }

  function initShopAllInfiniteScroll(section) {
    var grid = section.querySelector('[data-ww-v2-product-grid]');
    var loader = section.querySelector('[data-ww-v2-infinite-scroll]');
    var button = section.querySelector('[data-ww-v2-load-more]');
    var status = section.querySelector('[data-ww-v2-infinite-status]');
    var sectionHandle = getSectionHandle(section);
    var isLoading = false;

    if (!grid || !loader || !sectionHandle) return;

    function setStatus(message) {
      if (status) status.textContent = message;
    }

    async function loadNextPage() {
      var nextUrl = loader.dataset.nextUrl;
      if (!nextUrl || isLoading) return;

      isLoading = true;
      loader.classList.add('is-loading');
      setStatus('Loading more products...');

      try {
        var response = await fetch(sectionUrl(sectionHandle, nextUrl), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-ww-v2-product-grid]');
        var nextCards = nextGrid ? nextGrid.querySelectorAll('.ww-v2-product-card') : [];
        var nextLoader = doc.querySelector('[data-ww-v2-infinite-scroll]');

        if (nextCards.length === 0 && nextLoader && nextLoader.dataset.nextUrl) {
          loader.dataset.nextUrl = nextLoader.dataset.nextUrl;
          isLoading = false;
          loader.classList.remove('is-loading');
          await loadNextPage();
          return;
        }

        nextCards.forEach(function (card) {
          grid.appendChild(document.importNode(card, true));
        });

        if (nextLoader && nextLoader.dataset.nextUrl) {
          loader.dataset.nextUrl = nextLoader.dataset.nextUrl;
          setStatus('More products loaded. Keep scrolling for more.');
        } else {
          loader.removeAttribute('data-next-url');
          setStatus('');
          loader.style.display = 'none';
        }
      } catch (error) {
        setStatus('Unable to load more products. Please try again.');
      } finally {
        isLoading = false;
        loader.classList.remove('is-loading');
      }
    }

    if (button) {
      button.addEventListener('click', loadNextPage);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      }, { rootMargin: '500px 0px' });
      observer.observe(loader);
    }
  }

  async function refreshCachedShopAllSection() {
    if (!isShopAllCollection() || window.__wwShopAllRefreshApplied) return;

    var section = document.querySelector('[id^="shopify-section-template--"][id*="__ww_v2_collection"]');
    if (!section || section.querySelector('.ww-v2-goal-chips')) return;

    var sectionHandle = getSectionHandle(section);
    if (!sectionHandle) return;

    window.__wwShopAllRefreshApplied = true;

    try {
      var response = await fetch(sectionUrl(sectionHandle), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshShell = doc.querySelector('.ww-v2-shell');

      if (!freshShell || !freshShell.querySelector('.ww-v2-goal-chips')) return;

      section.innerHTML = freshShell.outerHTML;
      initShopAllInfiniteScroll(section);
    } catch (error) {
      window.__wwShopAllRefreshApplied = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCachedShopAllSection);
  } else {
    refreshCachedShopAllSection();
  }
})();
